import React from "react"
import PropTypes from "prop-types"
import css from "./ARIAButton.scss"

const ARIAButton = ({
    children,
    ariaLabel,
    ariaExpanded,
    ariaHasPopup,
    ariaPressed,
    isDisabled,
    onClick,
    tabIndex,
    role,
    type,
    ariaSelected,
    ariaControls,
    id,
    customClassName,
}) => {
    const giveAttributes = () => {
        const attr = {}
        if (ariaLabel) {
            attr["aria-label"] = ariaLabel
        }
        if (type) {
            attr["type"] = type
        }
        if (role) {
            attr["role"] = role
        }
        if (id) {
            attr["id"] = id
        }
        if (tabIndex) {
            attr["tabIndex"] = tabIndex
        }
        if (ariaControls) {
            attr["aria-controls"] = ariaControls
        }
        if (ariaSelected) {
            attr["aria-selected"] = ariaSelected
        }
        if (ariaHasPopup) {
            attr["aria-haspopup"] = ariaHasPopup
        }
        if (typeof ariaExpanded === "boolean") {
            attr["aria-expanded"] = ariaExpanded
        }
        if (typeof ariaPressed === "boolean") {
            attr["aria-pressed"] = ariaPressed
        }
        return attr
    }

    return (
        <button
            className={customClassName ? customClassName : css.ariaButton}
            onClick={onClick}
            disabled={isDisabled}
            {...giveAttributes()}
        >
            {children}
        </button>
    )
}

ARIAButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
    ariaExpanded: PropTypes.bool,
    ariaHasPopup: PropTypes.string,
    ariaPressed: PropTypes.bool,
    isDisabled: PropTypes.bool,
    tabIndex: PropTypes.number,
    role: PropTypes.string,
    type: PropTypes.string,
    ariaSelected: PropTypes.string,
    ariaControls: PropTypes.string,
    id: PropTypes.string,
    customClassName: PropTypes.string,
}

export default ARIAButton
